import React, { useState, useEffect } from 'react';
import './medical-advisory-applied-psychology.css';

import { Beaker, BrainCog, Scale, Rocket } from "lucide-react";

function MedicalAdvisoryAppliedPsychology() {
  const [activeSection, setActiveSection] = useState('overview');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setActiveSection(sectionId);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['overview', 'medical-advisory', 'clinical-nutrition', 'pediatric-nutrition', 'sports-nutrition', 'applied-psychology', 'aesthetic-advisory'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const domains = [
    'Internal Medicine', 'Endocrinology', 'Cardiology', 'Neurology',
    'Sports Medicine', 'Forensic Medicine', 'Medical Ethics & Legal Medicine',
    'Rehabilitation Medicine', 'Pain Medicine', 'Radiology Interpretation',
    'Pathology & Laboratory Science', 'Pharmacology & Drug Safety',
    'Public Health & Preventive Medicine', 'Occupational Health',
    'Clinical Nutrition & Dietetics', 'Pediatric & Maternity Nutrition',
    'Sports Nutrition', 'Clinical & Health Psychology', 'Behavioral Science',
    'Child Development Science', 'Educational Psychology', 'Sports Psychology',
    'Forensic Behavioral Analysis', 'Maternal & Family Psychology',
    'Nutritional Psychology', 'Organizational Psychology', 'AI Health Informatics'
  ];

  const psychDomains = [
    { title: "Cognitive Behavioral Advisory", desc: "CBT-based frameworks to reshape thinking patterns and behavioral responses. Outcome: A mind that thinks strategically, not reactively." },
    { title: "Child & Developmental Psychology", desc: "Behavioral guidance, emotional intelligence development, parent-child communication, early behavioral correction. Outcome: Emotionally stable, cognitively strong children." },
    { title: "School & Academic Psychology", desc: "Exam stress management, focus enhancement, learning behavior optimization, memory strategies, procrastination control. Outcome: Students who perform with confidence." },
    { title: "Maternity & Family Psychology", desc: "Pregnancy emotional adaptation, postpartum adjustment, family bonding, conflict reduction. Outcome: Psychologically healthy families." },
    { title: "Sports & Performance Psychology", desc: "Performance anxiety control, mental toughness training, focus enhancement, competitive mindset. Outcome: Athletes who perform with mental dominance." },
    { title: "Forensic & Behavioral Analysis", desc: "Behavioral interpretation, personality pattern assessment, human conduct analysis in legal contexts." },
    { title: "Workplace & Organizational Psychology", desc: "Leadership behavior optimization, burnout prevention, productivity enhancement, organizational culture." },
    { title: "Emotional Intelligence & Life Strategy", desc: "Emotional regulation, conflict resolution, relationship intelligence, personal growth planning." }
  ];

  const aiPsychologyServices = [
    { title: "Behavioral Data Analysis", desc: "Habit patterns, emotional triggers, decision-making trends, performance fluctuations" },
    { title: "AI-Assisted Psychological Profiling", desc: "Cognitive style profiles, behavioral tendency maps, emotional response patterns" },
    { title: "Real-Time Monitoring Systems", desc: "Mood tracking, habit tracking, stress level indicators" },
    { title: "Predictive Behavioral Modeling", desc: "Burnout risk prediction, behavioral relapse patterns, performance decline forecasting" },
    { title: "Digital Therapeutic Support", desc: "Guided psychological exercises, structured behavioral programs, interactive coaching modules" }
  ];

  return (
    <div className="maap-master-container">
      {/* Hero Banner Section */}
    <section className="maap-hero-section">

  {/* BACKGROUND IMAGE */}
  <img
    src="/medical-advisory-banner.jpeg"
    alt="Medical Advisory Banner"
    className="maap-hero-bg"
  />

  <div className="maap-hero-overlay"></div>
  <div className="maap-hero-pattern"></div>

  <div className="maap-hero-content">
    <div className="maap-hero-badge">DR. JERY MEDICO (PVT) LTD</div>

    <h1 className="maap-hero-title">
      Medical Advisory &<br />
      <span className="maap-hero-highlight">
        Applied Psychology Division
      </span>
    </h1>

    <p className="maap-hero-subtitle">
      Integrated Medical Intelligence, Behavioral Science & Human Performance Advisory
    </p>

    <div className="maap-hero-quote">
      <p>Transforming Healthcare Understanding Through Intelligence, Not Intervention</p>
    </div>

    <button
      className="maap-hero-cta"
      onClick={() => scrollToSection('overview')}
    >
      Explore Our Services
      <span className="maap-cta-arrow">→</span>
    </button>
  </div>

  <div className="maap-hero-scroll">
    <div className="maap-scroll-mouse"></div>
  </div>

</section>

      {/* Navigation Menu */}
      {/* <nav className={`maap-navbar ${scrolled ? 'maap-navbar-scrolled' : ''}`}>
        <div className="maap-nav-container">
  
          
          <button className="maap-mobile-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span></span><span></span><span></span>
          </button>

          <ul className={`maap-nav-menu ${isMenuOpen ? 'maap-nav-menu-open' : ''}`}>
            <li><button onClick={() => scrollToSection('overview')} className={activeSection === 'overview' ? 'active' : ''}>Overview</button></li>
            <li><button onClick={() => scrollToSection('medical-advisory')} className={activeSection === 'medical-advisory' ? 'active' : ''}>Medical</button></li>
            <li><button onClick={() => scrollToSection('clinical-nutrition')} className={activeSection === 'clinical-nutrition' ? 'active' : ''}>Nutrition</button></li>
            <li><button onClick={() => scrollToSection('pediatric-nutrition')} className={activeSection === 'pediatric-nutrition' ? 'active' : ''}>Pediatric</button></li>
            <li><button onClick={() => scrollToSection('sports-nutrition')} className={activeSection === 'sports-nutrition' ? 'active' : ''}>Sports</button></li>
            <li><button onClick={() => scrollToSection('applied-psychology')} className={activeSection === 'applied-psychology' ? 'active' : ''}>Psychology</button></li>
            <li><button onClick={() => scrollToSection('aesthetic-advisory')} className={activeSection === 'aesthetic-advisory' ? 'active' : ''}>Aesthetic</button></li>
          </ul>
        </div>
      </nav> */}

      {/* Introduction Section */}
<section id="overview" className="medai-intro">
  <div className="medai-container">

    <div className="medai-header">
      <span className="medai-tag">Introduction</span>
<h2 className="medai-title">
  Medical Intelligence    &nbsp; 
  <span className="medai-mobile-break"></span>
  & 
  <span className="medai-mobile-break"></span>
    &nbsp;  Human Behavior Advisory
</h2>
      <div className="medai-underline"></div>
    </div>

    <div className="medai-main-layout">

      {/* LEFT CONTENT */}
      <div className="medai-content">

        <p className="medai-lead">
          The Medical Advisory & Applied Psychology Division of DR. JERY MEDICO (PVT) LTD is a multidisciplinary advisory system designed to provide medical interpretation, behavioral insight, nutrition guidance, and performance-focused human optimization.
        </p>

        <div className="medai-block">
          <h3 className="medai-subtitle">
            Modern healthcare often leaves individuals confused by:
          </h3>

          <div className="medai-tags">
            <span className="medai-tag-item">Multiple medical reports</span>
            <span className="medai-tag-item">Complex diagnoses</span>
            <span className="medai-tag-item">Conflicting specialist opinions</span>
            <span className="medai-tag-item">Technical terminology</span>
            <span className="medai-tag-item">Fragmented healthcare advice</span>
          </div>
        </div>

        <div className="medai-block">
          <h3 className="medai-subtitle">Our division provides:</h3>

          <div className="medai-grid">
            <div className="medai-card">Medical interpretation</div>
            <div className="medai-card">Behavioral & psychological advisory</div>
            <div className="medai-card">Lifestyle & performance guidance</div>
            <div className="medai-card">Risk-aware decision support</div>
            <div className="medai-card">Evidence-based consultation</div>
          </div>
        </div>

        <div className="medai-note">
          We do not function as a treatment clinic or hospital.
          Instead, we provide strategic clarity and understanding.
        </div>

      </div>

      {/* RIGHT IMAGE */}
      <div className="medai-image-wrapper">
        <img
          src="/medical-advisory.jpeg"
          alt="Medical Advisory"
          className="medai-image"
        />
      </div>

    </div>

  </div>
</section>




      {/* Leadership Section */}
      <section className="maap-section maap-leadership-section">
        <div className="maap-container">
          <div className="maap-section-header">
            <span className="maap-section-tag">Leadership</span>
            <h2 className="maap-section-title">Dr. Eng. Jerish Neeraj</h2>
            <div className="maap-title-underline"></div>
            <p className="maap-section-subtitle">Founder & Chief Medical-Behavioral Strategist</p>
          </div>
          
          <div className="maap-leadership-card">
            <div className="maap-leadership-content">
              <p className="maap-leadership-qualifications">
                A uniquely multidisciplinary professional integrating:
              </p>
              <div className="maap-qualifications-grid">
                <span className="maap-qual-badge">MBBS</span>
                <span className="maap-qual-badge">BEng (Hons) Biomedical Engineering</span>
                <span className="maap-qual-badge">LLB (Hons)</span>
                <span className="maap-qual-badge">LLM (International Business Law)</span>
                <span className="maap-qual-badge">MSc (Data Science & AI Health Informatics)</span>
                <span className="maap-qual-badge">MPhil (Clinical Nutrition)</span>
                <span className="maap-qual-badge">MBA (Health Sector Management)</span>
                <span className="maap-qual-badge">DBA (Health Services Management)</span>
                <span className="maap-qual-badge">PhD in Psychology (Medical Law & Ethics)</span>
                <span className="maap-qual-badge">CMgr-MCPM</span>
              </div>
              <p className="maap-leadership-vision">
                The division integrates medicine, engineering, psychology, law, management, nutrition, and AI-driven health informatics into one advisory ecosystem.
              </p>
            </div>
            <div className="maap-leadership-image">
              <img src="/medical-advisory-dr-jery.jpeg" alt="Dr. Eng. Jerish Neeraj" />
              <div className="maap-leadership-badge">CEO & Founder</div>
            </div>
          </div>
        </div>
      </section>

      {/* Medical Advisory Section */}
      <section id="medical-advisory" className="maap-section maap-medical-section">
        <div className="maap-container">
          <div className="maap-section-header">
            <span className="maap-section-tag">Medical Advisory</span>
            <h2 className="maap-section-title">Medical Advisory & Clinical Interpretation</h2>
            <div className="maap-title-underline"></div>
            <p className="maap-section-subtitle">"Expert Interpretation for Better Medical Decisions"</p>
          </div>

          <div className="maap-two-column">
            <div className="maap-problem-box">
              <div className="maap-problem-icon">⚠️</div>
              <h3>What We Interpret</h3>
              <ul>
                <li>Laboratory investigations</li>
                <li>Hormonal and metabolic reports</li>
                <li>MRI, CT, ultrasound, and X-ray findings</li>
                <li>Specialist reports and discharge summaries</li>
                <li>Chronic disease management pathways</li>
              </ul>
            </div>
            <div className="maap-solution-box">
              <div className="maap-solution-icon">🎯</div>
              <h3>Areas of Focus</h3>
              <ul>
                <li>Diabetes and metabolic disorders</li>
                <li>Cardiovascular diseases</li>
                <li>Neurological conditions</li>
                <li>Autoimmune diseases</li>
                <li>Multi-system chronic conditions</li>
              </ul>
            </div>
          </div>

<div className="maap-advisory-model">
  <div className="maap-advisory-wrapper">
    
    {/* Left Image */}
    <div className="maap-advisory-image">
      <img src="/main-dr-jery-medico.jpeg" alt="Dr Jery Medico" />
    </div>

    {/* Right Content */}
    <div className="maap-advisory-content">
      <h3>Our Advisory Model</h3>

      <div className="maap-model-steps">
        <div className="maap-step">
          1. Clinical interpretation using evidence-based standards
        </div>

        <div className="maap-step">
          2. Risk identification and disease progression analysis
        </div>

        <div className="maap-step">
          3. Treatment clarification and pathway understanding
        </div>

        <div className="maap-step">
          4. Medication safety and interaction review
        </div>

        <div className="maap-step">
          5. Strategic non-prescriptive decision support
        </div>
      </div>
    </div>

  </div>
</div>

          <div className="maap-ethical-boundaries">
            <h3>Ethical Boundaries</h3>
            <div className="maap-boundaries-grid">
              <div className="maap-dont-box">
                <h4>❌ We DO NOT:</h4>
                <ul>
                  <li>Prescribe medications</li>
                  <li>Replace treating doctors</li>
                  <li>Provide emergency or hospital treatment</li>
                </ul>
              </div>
              <div className="maap-do-box">
                <h4>✅ We DO:</h4>
                <ul>
                  <li>Improve medical understanding</li>
                  <li>Reduce confusion and anxiety</li>
                  <li>Support informed decision-making</li>
                  <li>Strengthen doctor–patient communication</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="maap-suitable-for">
            <h3>Suitable For </h3>
            <div className="maap-suitable-grid">
              <span>Chronic disease patients </span>
              <span> VIP / high-net-worth clients </span>
              <span> Families managing complex conditions </span>
              <span> International remote advisory clients </span>
              <span> Medico-legal and insurance evaluations </span>
            </div>
          </div>
        </div>
      </section>



{/* MID BANNER */}
<section className="mlme-mid-banner-clinical-nutrition">

  <img
    src="/clinical-nutrition.jpeg"
    alt="Medico Legal Banner"
    className="mlme-mid-banner-img"
  />
</section>



      {/* Clinical Nutrition Section */}
      <section id="clinical-nutrition" className="maap-section maap-nutrition-section">
        <div className="maap-container">
          <div className="maap-section-header">
            <span className="maap-section-tag maap-section-tag-light">Nutrition</span>
            <h2 className="maap-section-title maap-title-light">Clinical Nutrition, Metabolic Health & Nutritional Psychology</h2>
            <div className="maap-title-underline maap-underline-light"></div>
            <p className="maap-section-subtitle maap-subtitle-light">"Precision Nutrition for Clinical and Lifestyle Optimization"</p>
          </div>

          <div className="maap-philosophy-box">
            <h3>Beyond Dieting: A Scientific Approach</h3>
            <p>Traditional dieting focuses on restriction. We focus on biological optimization and functional restoration.</p>
            <p>Each intervention is based on: Clinical diagnosis, Metabolic profiling, Disease-specific nutritional modulation, Behavioral and psychological assessment, and Long-term sustainability.</p>
          </div>

          <div className="maap-service-category">
            <h3>Clinical Nutrition Advisory Services</h3>
            <div className="maap-service-grid">
              <div className="maap-service-card maap-service-full">
                <div className="maap-service-icon"></div>
                <h4>Diabetes & Insulin Resistance Management</h4>
                <p>Targeted nutritional interventions to stabilize glucose metabolism and improve insulin sensitivity. Focus: Reducing HbA1c levels and improving metabolic control.</p>
              </div>
              <div className="maap-service-card maap-service-full">
                <div className="maap-service-icon"></div>
                <h4>Cardiovascular Disease Nutrition Support</h4>
                <p>Cardioprotective dietary frameworks to reduce risk factors and improve vascular health. Focus: Long-term cardiovascular risk reduction.</p>
              </div>
              <div className="maap-service-card maap-service-full">
                <div className="maap-service-icon"></div>
                <h4>Renal Disorder Nutritional Management</h4>
                <p>Carefully controlled nutritional strategies for kidney function preservation. Focus: Reducing kidney stress while maintaining nutritional adequacy.</p>
              </div>
              <div className="maap-service-card maap-service-full">
                <div className="maap-service-icon"></div>
                <h4>Liver Disease Nutrition Optimization</h4>
                <p>Hepatic recovery and metabolic stabilization through targeted nutrition. Focus: Supporting regeneration and reducing hepatic inflammation.</p>
              </div>
              <div className="maap-service-card maap-service-full">
                <div className="maap-service-icon"></div>
                <h4>Gastrointestinal & Digestive Health Nutrition</h4>
                <p>Gut function as a central pillar of systemic health. Focus: Restoring digestive efficiency and microbiome stability.</p>
              </div>
              <div className="maap-service-card maap-service-full">
                <div className="maap-service-icon"></div>
                <h4>Hormonal Imbalance Nutrition (PCOS, Thyroid & Endocrine Health)</h4>
                <p>Endocrine physiology integrated with nutritional correction strategies. Focus: Restoring hormonal equilibrium through metabolic nutrition.</p>
              </div>
            </div>
          </div>


<section className="mlme-mid-banner-full">
  <img
    src="/healthy-nutrition.jpeg"
    alt="Healthy Nutrition Banner"
    className="mlme-mid-banner-img"
  />
</section>



          <div className="maap-service-category">
            <h3>Non-Clinical & Lifestyle Nutrition</h3>
            <div className="maap-service-grid">
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Weight Management</h4>
                <p>Personalized caloric structuring, metabolic rate-based planning, sustainable fat reduction, lean muscle development</p>
              </div>
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Longevity & Healthy Aging</h4>
                <p>Cellular aging reduction, anti-oxidative nutrition, inflammation control, brain health nutrition</p>
              </div>
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Preventive Health Nutrition</h4>
                <p>Chronic disease risk reduction, immunity support, lifestyle disease prevention</p>
              </div>
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Energy Optimization</h4>
                <p>Cognitive performance nutrition, fatigue reduction, circadian rhythm-aligned eating</p>
              </div>
            </div>
          </div>

          <div className="maap-nutritional-psychology">
            <h3>Nutritional Psychology (Advanced Domain)</h3>
            <p>Where medicine meets behavioral science. We analyze how mind-driven behaviors directly control nutritional outcomes, metabolic health, and disease progression.</p>
            <div className="maap-psychology-grid">
              <div className="maap-psych-card">Emotional Eating Patterns</div>
              <div className="maap-psych-card">Stress-Related Eating Behavior</div>
              <div className="maap-psych-card">Dopamine-Driven Consumption Cycles</div>
              <div className="maap-psych-card">Food Addiction & Compulsive Eating</div>
            </div>
            <div className="maap-core-model">
              <h4>Our Core Therapeutic Model</h4>
              <p className="maap-model-flow">Mind → Behavior → Nutrition → Physiology</p>
            </div>
          </div>
        </div>
      </section>


{/* MID BANNER */}
<section className="mlme-mid-banner">

  <img
    src="/Maternity-Nutrition-mid-banner.jpeg"
    alt="Medico Legal Banner"
    className="mlme-mid-banner-img"
  />
</section>


      {/* Pediatric & Maternity Nutrition Section */}
      <section id="pediatric-nutrition" className="maap-section maap-pediatric-section">
        <div className="maap-container">
          <div className="maap-section-header">
            <span className="maap-section-tag">Pediatric & Maternity</span>
            <h2 className="maap-section-title">Pediatric & Maternity Nutrition Advisory</h2>
            <div className="maap-title-underline"></div>
            <p className="maap-section-subtitle">"Building Health from the Earliest Stages of Life"</p>
          </div>

          <div className="maap-two-column">
            <div className="maap-pediatric-box">
              <div className="maap-pediatric-icon"></div>
              <h3>Pediatric Nutrition</h3>
              <p><strong>Precision Nutrition for Growing Minds and Bodies</strong></p>
              <h4>What We Address:</h4>
              <ul>
                <li>Infant feeding and weaning</li>
                <li>Childhood growth concerns</li>
                <li>Micronutrient deficiencies</li>
                <li>Gut health and immunity</li>
                <li>Behavioral eating issues</li>
                <li>Picky eating and food refusal patterns</li>
              </ul>
              <div className="maap-outcome-focus">
                <strong>Outcome Focus:</strong> Healthy growth, improved concentration, better immunity, balanced eating habits
              </div>
            </div>
            <div className="maap-maternity-box">
              <div className="maap-maternity-icon"></div>
              <h3>Maternity Nutrition</h3>
              <p><strong>Supporting Mother & Child Through Every Stage</strong></p>
              <h4>Scope of Advisory:</h4>
              <ul>
                <li><strong>Fertility nutrition</strong> - Hormonal balance, nutritional preparation</li>
                <li><strong>Pregnancy nutritional planning</strong> - Trimester-based support</li>
                <li><strong>Gestational diabetes guidance</strong> - Blood sugar management</li>
                <li><strong>Postpartum recovery support</strong> - Healing and lactation</li>
              </ul>
              <div className="maap-psychological-integration">
                <strong>Psychological Integration:</strong> Pregnancy-related anxiety, mood fluctuations, postpartum emotional adjustment, parent-child bonding support
              </div>
            </div>
          </div>

          <div className="maap-ethical-note">
            <p>⚠️ <strong>Ethical Positioning:</strong> We do not replace obstetricians or pediatricians. We provide educational and supportive advisory services only.</p>
          </div>

          <div className="maap-integrated-box">
            <p className="maap-integrated-text">Mother's Health → Child's Development → Lifelong Outcomes</p>
          </div>
        </div>
      </section>

      {/* Sports & Performance Nutrition */}
      <section id="sports-nutrition" className="maap-section maap-sports-section">
        <div className="maap-container">
          <div className="maap-section-header">
            <span className="maap-section-tag maap-section-tag-light">Sports</span>
            <h2 className="maap-section-title maap-title-light">Sports & Performance Nutrition</h2>
            <div className="maap-title-underline maap-underline-light"></div>
            <p className="maap-section-subtitle maap-subtitle-light">"Fueling Human Performance Beyond Limits"</p>
          </div>

          <div className="maap-sports-intro">
            <p>Elite performance is not achieved only through training—it is engineered through precise nutrition, metabolic optimization, and scientifically guided recovery strategies.</p>
          </div>

          <div className="maap-service-grid">
            <div className="maap-service-card maap-service-full">
              <div className="maap-service-icon"></div>
              <h3>Athlete-Specific Diet Planning</h3>
              <p>Sport-specific macronutrient structuring, periodized nutrition plans, body composition optimization, pre-season/in-season/off-season strategies, performance goal-based meal structuring.</p>
              <div className="maap-service-note">✓ Medically interpreted and performance-validated</div>
            </div>
            <div className="maap-service-card maap-service-full">
              <div className="maap-service-icon"></div>
              <h3>Recovery Optimization Programs</h3>
              <p>Post-training recovery protocols, muscle glycogen restoration, anti-inflammatory dietary interventions, sleep-supportive nutrition, injury recovery support, fatigue management.</p>
              <div className="maap-service-note">✓ Faster recovery = more consistent elite performance</div>
            </div>
            <div className="maap-service-card maap-service-full">
              <div className="maap-service-icon"></div>
              <h3>Muscle Metabolism & Performance Enhancement</h3>
              <p>Protein metabolism optimization, energy system enhancement, lean muscle development, hormonal balance support, supplement guidance, metabolic efficiency profiling.</p>
              <div className="maap-service-note">✓ High-efficiency performance engine</div>
            </div>
            <div className="maap-service-card maap-service-full">
              <div className="maap-service-icon"></div>
              <h3>Hydration & Electrolyte Balance Management</h3>
              <p>Personalized hydration calculation, electrolyte replacement planning, heat stress management protocols, pre/intra/post-training hydration strategies, travel and climate adaptation.</p>
              <div className="maap-service-note">✓ Designed for Sri Lanka's tropical climate</div>
            </div>
          </div>

          <div className="maap-sports-who-we-serve">
            <h3>Who We Work With</h3>
            <div className="maap-sports-grid">
              <span>Professional athletes (cricket, rugby, athletics, combat sports)</span>
              <span>School and university athletes</span>
              <span>Fitness and bodybuilding clients</span>
              <span>Injury recovery patients returning to sport</span>
              <span>High-performance professionals (military, police, endurance workers)</span>
            </div>
          </div>

          <div className="maap-sports-outcomes">
            <h3>Measurable Performance Improvement</h3>
            <div className="maap-outcomes-grid">
              <span>✓ Increased strength & endurance</span>
              <span>✓ Faster recovery cycles</span>
              <span>✓ Improved body composition</span>
              <span>✓ Reduced injury risk</span>
              <span>✓ Optimized energy levels</span>
              <span>✓ Enhanced competitive performance</span>
            </div>
          </div>
        </div>
      </section>


      <section className="mlme-mid-banner-ai-second">

  <img
    src="/phsycology-first-mid-banner.jpeg"
    alt="Medico Legal Banner"
    className="mlme-mid-banner-ai-second-img"
  />
</section>








      {/* Applied Psychology Section */}
      <section id="applied-psychology" className="maap-section maap-psychology-main-section">
        <div className="maap-container">
          <div className="maap-section-header">
            <span className="maap-section-tag">Psychology</span>
            <h2 className="maap-section-title">Applied Psychology & Human Behavior Advisory</h2>
            <div className="maap-title-underline"></div>
            <p className="maap-section-subtitle">"Engineering Human Behavior, Emotion, and Performance"</p>
          </div>

          <div className="maap-philosophy-box maap-psych-philosophy">
            <h3>Core Philosophy</h3>
            <p>Psychology is not only about treating illness—it is about engineering human potential.</p>
            <p>Every behavior can be analyzed, every thought can be restructured, and every outcome can be optimized.</p>
            <p className="maap-model-flow">Cognition → Emotion → Behavior → Outcome</p>
          </div>

          <div className="maap-service-category">
            <h3>Key Domains of Applied Psychology</h3>
            <div className="maap-psych-domains-grid">
              {psychDomains.map((domain, idx) => (
                <div key={idx} className="maap-psych-domain">
                  <div className="maap-psych-domain-icon"></div>
                  <h4>{domain.title}</h4>
                  <p>{domain.desc}</p>
                </div>
              ))}
            </div>
          </div>




{/* Advanced Psychological Services */}
<div className="medai-psych-services">
  <h3 className="medai-section-title">Advanced Psychological Services</h3>

  <div className="medai-psych-grid">
    <div className="medai-psych-card">
      <h4>Neurocognitive Optimization</h4>
      <p>Attention span enhancement, cognitive processing speed improvement, mental fatigue reduction</p>
    </div>

    <div className="medai-psych-card">
      <h4>Behavioral Addiction Advisory</h4>
      <p>Digital addiction, food-related behavioral dependencies, habit loop analysis</p>
    </div>

    <div className="medai-psych-card">
      <h4>Life Transition Psychology</h4>
      <p>Career change, divorce/separation adjustment, migration preparation, identity realignment</p>
    </div>

    <div className="medai-psych-card">
      <h4>Decision-Making Psychology</h4>
      <p>Risk assessment frameworks, bias identification, high-stakes decision support</p>
    </div>
  </div>
</div>

{/* AI Psychology Section */}
<div className="medai-ai-section">
  <h3 className="medai-section-title">AI & Health Informatics in Psychology</h3>

  <p className="medai-ai-subtitle">
    From Subjective Psychology to Data-Driven Behavioral Intelligence
  </p>

  <div className="medai-ai-grid">
    {aiPsychologyServices.map((service, idx) => (
      <div key={idx} className="medai-ai-card">
        <div className="medai-ai-icon">
  <BrainCog size={18} />
</div>
        <h4>{service.title}</h4>
        <p>{service.desc}</p>
      </div>
    ))}
  </div>

  <div className="medai-ai-ethics">
    <p>
      <strong>Ethical Data Governance:</strong> Strict confidentiality, secure data storage, ethical AI use in psychological analysis
    </p>
  </div>
</div>




          <div className="maap-ethical-boundaries">
            <h3>Ethical Boundary</h3>
            <div className="maap-boundaries-grid">
              <div className="maap-dont-box">
                <h4>❌ We DO NOT:</h4>
                <ul>
                  <li>Diagnose psychiatric disorders</li>
                  <li>Treat severe mental illness</li>
                  <li>Prescribe psychiatric medications</li>
                  <li>Replace psychiatrists or clinical psychologists</li>
                </ul>
              </div>
              <div className="maap-do-box">
                <h4>✅ We DO:</h4>
                <ul>
                  <li>Provide structured psychological coaching</li>
                  <li>Optimize behavior and performance</li>
                  <li>Enhance emotional stability</li>
                  <li>Support strategic life decisions</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="maap-final-value">
            <p>We are not a counseling center. We are not a therapy clinic.</p>
            <p className="maap-final-highlight">We are a Human Behavior Engineering System where psychology becomes performance.</p>
          </div>
        </div>
      </section>


      {/* MID BANNER */}
<section className="mlme-mid-banner-ai-second">

  <img
    src="/phsycology-mid-banner.jpeg"
    alt="Medico Legal Banner"
    className="mlme-mid-banner-ai-second-img"
  />
</section>

      {/* Aesthetic Advisory Section */}
      <section id="aesthetic-advisory" className="maap-section maap-aesthetic-section">
        <div className="maap-container">
          <div className="maap-section-header">
            <span className="maap-section-tag maap-section-tag-light">Aesthetic</span>
            <h2 className="maap-section-title maap-title-light">Aesthetic, Dermatological & Cosmetic Advisory</h2>
            <div className="maap-title-underline maap-underline-light"></div>
            <p className="maap-section-subtitle maap-subtitle-light">"Scientific Beauty with Medical Insight"</p>
          </div>

          <div className="maap-philosophy-box">
            <h3>Core Philosophy</h3>
            <p>Beauty is not just cosmetic—it is biological, structural, and physiological.</p>
            <p>True aesthetic optimization begins with understanding the skin, not altering it blindly.</p>
            <p className="maap-aesthetic-note">We provide medically informed, evidence-based aesthetic guidance without performing procedures.</p>
          </div>

          <div className="maap-service-category">
            <h3>Clinical Advisory Services</h3>
            <div className="maap-service-grid">
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Skin Condition Interpretation</h4>
                <p>Skin type and barrier function, inflammatory conditions, environmental and lifestyle impact, root causes affecting skin health</p>
              </div>
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Acne & Breakout Analysis</h4>
                <p>Hormonal and lifestyle-related acne, stress and diet-related flare-ups, product-induced irritation</p>
              </div>
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Pigmentation & Skin Tone Analysis</h4>
                <p>Hyperpigmentation patterns, sun damage, hormonal pigmentation, uneven skin tone causes</p>
              </div>
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Aging & Skin Longevity</h4>
                <p>Preventive anti-aging guidance, collagen-supportive strategies, long-term skin preservation planning</p>
              </div>
            </div>
          </div>

          <div className="maap-service-category">
            <h3>Cosmetic & Skincare Advisory</h3>
            <div className="maap-service-grid">
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Cosmetic Procedure Decision Support</h4>
                <p>Botox and fillers, laser procedures, chemical peels, benefits, risks, and realistic outcomes</p>
              </div>
              <div className="maap-service-card">
                <div className="maap-service-icon"></div>
                <h4>Personalized Skincare Advisory</h4>
                <p>Customized skincare routines, product selection guidance, ingredient-focused strategies, long-term skin maintenance</p>
              </div>
            </div>
          </div>

          <div className="maap-aesthetic-psychology">
            <h3>Aesthetic Psychology</h3>
            <div className="maap-psychology-grid">
              <div className="maap-psych-card">Body Image Perception</div>
              <div className="maap-psych-card">Social Media Influence</div>
              <div className="maap-psych-card">Cosmetic Decision-Making Behavior</div>
              <div className="maap-psych-card">Confidence & Identity Alignment</div>
            </div>
          </div>

          <div className="maap-ai-integration">
            <h3>AI & Digital Skin Analysis</h3>
            <div className="maap-ai-features">
              <span>AI-based skin mapping</span> &nbsp;
              <span>Predictive aging analysis</span> &nbsp;
              <span>Progress monitoring systems</span> &nbsp;
              <span>Personalized digital profiling</span>
            </div>
          </div>

          <div className="maap-ethical-boundaries">
            <div className="maap-boundaries-grid">
              <div className="maap-dont-box">
                <h4>❌ We DO NOT:</h4>
                <ul>
                  <li>Perform cosmetic procedures</li>
                  <li>Prescribe medications</li>
                  <li>Replace dermatologists or cosmetic surgeons</li>
                </ul>
              </div>
              <div className="maap-do-box">
                <h4>✅ We DO:</h4>
                <ul>
                  <li>Provide evidence-based guidance</li>
                  <li>Help clients make informed aesthetic decisions</li>
                  <li>Promote long-term skin health</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="maap-aesthetic-outcomes">
            <h3>Outcome Goals</h3>
            <div className="maap-outcomes-grid">
              <span>✓ Better understanding of skin health</span>
              <span>✓ Reduced unnecessary procedures</span>
              <span>✓ Smarter skincare investments</span>
              <span>✓ Sustainable aesthetic improvement</span>
            </div>
          </div>
        </div>
      </section>



{/* MID BANNER */}
<section className="mlme-mid-banner-ai-second">

  <img
    src="/cosmetics.jpeg"
    alt="Medico Legal Banner"
    className="mlme-mid-banner-ai-second-img"
  />
</section>






  

<section className="medai-unique-section">
  <div className="medai-container">

    <div className="medai-section-header">
      <span className="medai-section-tag">Why Choose Us</span>
      <h2 className="medai-section-title">Why This Division Is Unique</h2>
      <div className="medai-title-underline"></div>
    </div>

    <div className="medai-unique-grid">

      <div className="medai-unique-card">
        <div className="medai-unique-icon">
          <Beaker size={20} />
        </div>
        <h3>Multidisciplinary Integration</h3>
        <p>Medicine + Psychology + Nutrition + AI + Behavior + Aesthetics</p>
      </div>

      <div className="medai-unique-card">
        <div className="medai-unique-icon">
          <BrainCog size={20} />
        </div>
        <h3>Intelligence-Based Model</h3>
        <p>Interpretation, clarity, and strategic advisory rather than treatment</p>
      </div>

      <div className="medai-unique-card">
        <div className="medai-unique-icon">
          <Scale size={20} />
        </div>
        <h3>Ethical & Non-Prescriptive</h3>
        <p>Educational, evidence-based, and professionally compliant</p>
      </div>

      <div className="medai-unique-card">
        <div className="medai-unique-icon">
          <Rocket size={20} />
        </div>
        <h3>Future-Ready Vision</h3>
        <p>AI health analytics, behavioral prediction systems, digital health informatics</p>
      </div>

    </div>
  </div>
</section>

      {/* Final Positioning */}
    <section className="medai-closing-section">
  <div className="medai-container">

    <div className="medai-closing-card">

      <div className="medai-quote-mark">“</div>

      <p className="medai-closing-text">
        DR. JERY MEDICO (PVT) LTD is not a conventional clinic, therapy center, or coaching platform.
      </p>

      <p className="medai-closing-highlight">
        It is a structured Medical & Human Intelligence Advisory System
      </p>

      <div className="medai-pill-group">
        <span>Medical clarity</span>
        <span>Behavioral insight</span>
        <span>Performance optimization</span>
        <span>Nutritional intelligence</span>
        <span>Strategic health guidance</span>
      </div>

      <p className="medai-closing-footer">
        We empower individuals, families, professionals, and organizations through science-driven understanding, ethical advisory, and integrated human-centered intelligence.
      </p>

    </div>

  </div>
</section>


    </div>
  );
}

export default MedicalAdvisoryAppliedPsychology;